import { Flex, Tooltip } from "@mantine/core";
import {
  CloseCircle,
  InfoCircle,
  MinusCirlce,
  TickCircle,
} from "iconsax-react";
import React from "react";
import { EColorIconInfo } from "../../../../interfaces/OrderPostions";

interface IProps {
  statusCopy: EColorIconInfo;
  statusCopyText: string;
}

export default function IconInfo({ statusCopy, statusCopyText }: IProps) {
  const variantColors: Record<
    EColorIconInfo,
    { color: string; icon: React.ReactNode }
  > = {
    GREEN: {
      color: "#00C853",
      icon: <TickCircle size="20" color="#00C853" variant="Bold" />,
    },
    RED: {
      color: "#F43B3B",
      icon: <CloseCircle size="20" color="#F43B3B" variant="Bold" />,
    },
    YELLOW: {
      color: "#F5A623",
      icon: <InfoCircle size="20" color="#F5A623" variant="Bold" />,
    },
    WHITE: {
      color: "#FFFFFF",
      icon: <MinusCirlce size="20" color="#FFFFFF" variant="Bold" />,
    },
    GRAY: {
      color: "#495057",
      icon: <InfoCircle size="20" color="#495057" variant="Bold" />,
    },
  };

  const selectedVariant =
    variantColors[statusCopy] || variantColors[EColorIconInfo.WHITE];

  return (
    // <Tooltip label={statusCopyText} withArrow zIndex={1000}>
    <Flex justify={"center"} align={"center"}>
      {selectedVariant.icon}
    </Flex>
    // </Tooltip>
  );
}
